module.exports = __webpack_public_path__ + "images/eyeClosed-b3679686dae41e2f3b6d1ab96d170c34.svg";